<template>
<div class="container-fluid" id="top_level_container">
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" id="stammdaten-tab" data-toggle="tab" href="#stammdaten" role="tab" aria-controls="stammdaten" aria-selected="true">Stammdaten</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="preise-tab" data-toggle="tab" href="#preise" role="tab" aria-controls="preise" aria-selected="false">Preise</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="history-tab" data-toggle="tab" href="#history" role="tab" aria-controls="history" aria-selected="false">Historie</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="activities-tab" data-toggle="tab" href="#activities" role="tab" aria-controls="activities" aria-selected="false">Änderungen</a>
    </li>
  </ul>

  <div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="stammdaten" role="tabpanel" aria-labelledby="stammdaten-tab">
      <br/>
      <img v-show="loadingDetails" width="5%" src="../assets/spinner.gif"></image>
      <div v-show="!loadingDetails">
        <div class="form-group row">
          <label for="inputId" class="col-sm-3 col-form-label">ID</label>
          <div class="col-sm-9">
            {{product.id}}
          </div>
        </div>
        <div class="form-group row">
          <label for="inputCcsId" class="col-sm-3 col-form-label">CCS-ID</label>
          <div class="col-sm-9 input-group">
            <input type="text" class="form-control" id="inputCcsId" v-model="product.ccsId">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputCcsName" class="col-sm-3 col-form-label">CCS-Name</label>
          <div class="col-sm-9 input-group">
            {{product.ccsName}}
          </div>
        </div>
        <div class="form-group row">
          <label for="inputCcsManufacturer" class="col-sm-3 col-form-label">CCS-Hersteller</label>
          <div class="col-sm-9 input-group">
            {{product.ccsManufacturer}}
          </div>
        </div>
        <div class="form-group row">
          <label for="inputCcsProductmanager" class="col-sm-3 col-form-label">CCS-Produktmanager</label>
          <div class="col-sm-9 input-group">
            {{product.ccsProductmanager}}
          </div>
        </div>
        <div class="form-group row">
          <label for="inputAsinEk1" class="col-sm-3 col-form-label">ASIN EK1 EK2 VK1 VK2</label>
          <div class="col-sm-2">
            <input type="text" class="form-control" id="inputAsinEk1" placeholder="EK1" v-model="product.asinEk1">
          </div>
          <div class="col-sm-2">
            <input type="text" class="form-control" id="inputAsinEk2" placeholder="EK2" v-model="product.asinEk2">
          </div>
          <div class="col-sm-2">
            <input type="text" class="form-control" id="inputAsinVk1" placeholder="VK1" v-model="product.asinVk1">
          </div>
          <div class="col-sm-2">
            <input type="text" class="form-control" id="inputAsinVk2" placeholder="VK2" v-model="product.asinVk2">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputSysteam" class="col-sm-3 col-form-label">Systeam-ID</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="inputName" v-model="product.systeam">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputSysteamMindestbestand" class="col-sm-3 col-form-label">Systeam-Mindestbestand</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="inputName" v-model.number="product.systeamMindestbestand">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputConradId" class="col-sm-3 col-form-label">Conrad-ID</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="inputConradId" v-model="product.conradId">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputConradActive" class="col-sm-3 col-form-label">Conrad Active</label>
          <div class="col-sm-9">
            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="inputConradActive0" v-model.number="product.conradActive" v-bind:value="0">
              <label class="form-check-label" for="inputConradActive0">
                0
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="inputConradActive1" v-model.number="product.conradActive" v-bind:value="1">
              <label class="form-check-label" for="inputConradActive1">
                1
              </label>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="inputSchwellwert" class="col-sm-3 col-form-label">Schwellwert</label>
          <div class="col-sm-9 input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroupPrepend2">€</span>
            </div>
            <input type="text" class="form-control" id="inputName" v-model="product.schwellwert">
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-9">
            <button type="submit" class="btn btn-primary" v-on:click="saveChanges">Änderungen speichern</button>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-pane fade" id="preise" role="tabpanel" aria-labelledby="preise-tab">
      <br/>
      <img v-show="loadingPreise" width="5%" src="../assets/spinner.gif">

      <div v-for="id in getIdsInPrices(prices)" class="ids">
        <h3>{{id.id}} ({{id.idType}})</h3>

        <div v-for="shopName in getShopNamesForIdInPrices(id.id, prices)" class="shopNames">
          <h4>{{shopName}}</h4>

          <table class="table table-sm" v-show="!loadingPreise">
            <thead class="thead-dark">
              <tr>
                <th>ID-Typ</th>
                <th>ID</th>
                <th>Shop-Name</th>
                <th>Price-Typ</th>
                <th style="text-align:right;">Preis</th>
                <th style="text-align:center;">Abweichung</th>
                <th style="text-align:right;">VAT</th>
                <th style="text-align:right;">Währungsumrechung</th>
                <th style="text-align:right;">Inventory</th>
                <th>Abrufdatum</th>
                <th>Retrieval</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="price in getPricesForShopAndIdInPrices(id.id, shopName, prices)" v-show="!price.priceIsInvalid" v-bind:class="{ 'table-success': (price.amount <  product.schwellwert), 'mainPrice': price.isMainPrice}">
                <td><span v-show="price.priceIsOld" class="oi oi-warning" style="color:red;" title="Dieser Preis ist relativ alt und evtl. nicht mehr gültig!"></span>&nbsp;{{price.idType}}</span></td>
                <td>{{price.id}}</span></td>
                <td>{{price.shopName}}</td>
                <td>
                  {{price.priceType}}&nbsp;<span v-show="price.priceIsInvalid" class="oi oi-warning" style="color:red;"></span>
                </td>
                <td style="text-align:right;">{{price.amount.toFixed(2)}}&nbsp;€</td>
                <td style="text-align:center;">{{(price.amount/product.schwellwert*100-100).toFixed(0)}}%</td>
                <td style="text-align:right;">{{price.vatUsedForConversion}}</td>
                <td style="text-align:right;">{{price.exchangeRateUsedForConversion}}</td>
                <td style="text-align:right;">{{price.inventoryAvailable}}</td>
                <td>{{moment(price.lastRetrieved).format('DD.MM.YYYY HH:mm')}}</td>
                <td>{{price.retrievalId}}</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

    <div class="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab">
      <br/>
      <img v-show="loadingHistory" width="5%" src="../assets/spinner.gif">

      <div id="all_charts"></div>
    </div>


    <div class="tab-pane fade" id="activities" role="tabpanel" aria-labelledby="activities-tab">
      <br/>
      <img v-show="loadingActivities" width="5%" src="../assets/spinner.gif">

      <table>
        <tr v-for="a in activities" class="activity">
          <td valign="top">
            <img :src="getGravatarUrl(a.user.email)" style="margin-right:10px;"/>
          </td>
          <td>
            <strong>Das Produkt wurde aktualisiert.</strong>
            <br/>
            {{moment(a.timestamp).format('DD.MM.YYYY HH:mm')}} von {{a.user.name}}
            <br/>
            <br/>
            <table class="table table-sm table-bordered" style="margin-left: 0px; margin-bottom: 30px;">
              <thead class="thead-light">
                <tr>
                  <th>Attribut</th>
                  <th>Alter Wert</th>
                  <th>Neuer Wert</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="change in a.changes">
                  <td>{{change.fieldName}}</td>
                  <td>{{change.oldValue}}</td>
                  <td>{{change.newValue}}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </table>
    </div>


  </div>
</div>
</template>

<script>
export default {
  name: 'EditProduct',
  props:['id'],
  data () {
    return {
      product: {},
      prices: [],
      activities: {},
      history: {},
      loadingDetails: false,
      loadingPreise: true,
      loadingActivities: true,
      loadingHistory: true,
    }
  },

  created: function () {
    google.charts.load('current', {packages: ['corechart', 'line']});
    //google.charts.setOnLoadCallback(drawCharts);
  },

  mounted: function () {
    console.log("Loading product with ID " + this.id);
    this.loadProduct();
    this.loadPreise();
    this.loadActivities();
    // Öffne einen der Tabs direkt, wenn sich der richtige Tab-Name im Hash befindet (ansonsten wird ein Fehler geworfen, aber den ignorieren wir einfach mal)
    $('#myTab a[href="'+window.location.hash+'"]').tab('show');
  },

  methods: {

    saveChanges: function() {
     console.log("Saving changes now:");
     console.log(this.product);
     fetch("https://07s1fhg37a.execute-api.eu-central-1.amazonaws.com/prod/products/" + this.id, {
       method: 'PUT',
       headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + localStorage.token
       },
       body:JSON.stringify(this.product)
     })
        .then(response => {
         if (response.status === 401) {
           delete localStorage.token;
           delete localStorage.username;
           delete localStorage.name;
           delete localStorage.email;
           this.$router.push('/login?redirect=' + this.$route.path);
         }
         return response.json();
        })
        .then((data) =>  {
          toastr.success('Die Änderungen wurden gespeichert.');
          this.loadActivities();
        })
        .catch((err) => {
          console.log(err);
          toastr.error('Die Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es noch einmal. Falls das Problem wieder auftritt, informieren Sie bitte den Administrator.');
        })
    },

    loadProduct: function() {
      this.loadingDetails = true;
      fetch("https://07s1fhg37a.execute-api.eu-central-1.amazonaws.com/prod/products/" + this.id, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.token
        },
      })
        .then(response => {
         if (response.status === 401) {
           delete localStorage.token;
           delete localStorage.username;
           delete localStorage.name;
           delete localStorage.email;
           this.$router.push('/login?redirect=' + this.$route.path);
         }
         return response.json();
        })
        .then((data) => {
          this.product = data[0];
          this.loadingDetails = false;
        })
        .catch((err) => {
          console.log(err)
          this.loadingDetails = false;
        });
    },

    loadPreise: function() {
      this.loadingPreise = true;
      fetch("https://07s1fhg37a.execute-api.eu-central-1.amazonaws.com/prod/products/" + this.id + "/prices", {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.token
        },
      })
        .then(response => {
         if (response.status === 401) {
           delete localStorage.token;
           delete localStorage.username;
           delete localStorage.name;
           delete localStorage.email;
           this.$router.push('/login?redirect=' + this.$route.path);
         }
         return response.json();
        })
        .then((data) => {
          this.prices = data;
          this.loadingPreise = false;

          var ids = this.getAllIdsFromCurrentProduct();
          console.log(ids);
          for (var i=0; i<ids.length; i++) {
            this.loadHistory(ids[i].idType, ids[i].id);
          }
        })
        .catch((err) => {
          console.log(err);
          this.loadingPreise = false;
        });
    },

    loadHistory: function(idType, id) {
      this.loadingHistory = false;
      fetch("https://07s1fhg37a.execute-api.eu-central-1.amazonaws.com/prod/retrievals/prices/history?id_type="+idType+"&id="+id+"&count=2000", {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.token
        },
      })
        .then(response => {
         if (response.status === 401) {
           delete localStorage.token;
           delete localStorage.username;
           delete localStorage.name;
           delete localStorage.email;
           this.$router.push('/login?redirect=' + this.$route.path);
         }
         return response.json();
        })
        .then((data) => {
          this.history = data;
          this.loadingHistory = false;
          this.drawChart(idType, id, data);
        })
        .catch((err) => {
          console.log(err);
          this.loadingHistory = false;
        });
    },

    loadActivities: function() {
      this.loadingActivities = true;
      fetch("https://07s1fhg37a.execute-api.eu-central-1.amazonaws.com/prod/products/" + this.id + "/activities", {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.token
        },
      })
        .then(response => {
         if (response.status === 401) {
           delete localStorage.token;
           delete localStorage.username;
           delete localStorage.name;
           delete localStorage.email;
           this.$router.push('/login?redirect=' + this.$route.path);
         }
         return response.json();
        })
        .then((data) => {
          this.activities = data;
          this.loadingActivities = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingActivities = false;
        });
    },

    getGravatarUrl: function(email) {
      var MD5=function(s){function L(k,d){return(k<<d)|(k>>>(32-d))}function K(G,k){var I,d,F,H,x;F=(G&2147483648);H=(k&2147483648);I=(G&1073741824);d=(k&1073741824);x=(G&1073741823)+(k&1073741823);if(I&d){return(x^2147483648^F^H)}if(I|d){if(x&1073741824){return(x^3221225472^F^H)}else{return(x^1073741824^F^H)}}else{return(x^F^H)}}function r(d,F,k){return(d&F)|((~d)&k)}function q(d,F,k){return(d&k)|(F&(~k))}function p(d,F,k){return(d^F^k)}function n(d,F,k){return(F^(d|(~k)))}function u(G,F,aa,Z,k,H,I){G=K(G,K(K(r(F,aa,Z),k),I));return K(L(G,H),F)}function f(G,F,aa,Z,k,H,I){G=K(G,K(K(q(F,aa,Z),k),I));return K(L(G,H),F)}function D(G,F,aa,Z,k,H,I){G=K(G,K(K(p(F,aa,Z),k),I));return K(L(G,H),F)}function t(G,F,aa,Z,k,H,I){G=K(G,K(K(n(F,aa,Z),k),I));return K(L(G,H),F)}function e(G){var Z;var F=G.length;var x=F+8;var k=(x-(x%64))/64;var I=(k+1)*16;var aa=Array(I-1);var d=0;var H=0;while(H<F){Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=(aa[Z]|(G.charCodeAt(H)<<d));H++}Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=aa[Z]|(128<<d);aa[I-2]=F<<3;aa[I-1]=F>>>29;return aa}function B(x){var k="",F="",G,d;for(d=0;d<=3;d++){G=(x>>>(d*8))&255;F="0"+G.toString(16);k=k+F.substr(F.length-2,2)}return k}function J(k){k=k.replace(/rn/g,"n");var d="";for(var F=0;F<k.length;F++){var x=k.charCodeAt(F);if(x<128){d+=String.fromCharCode(x)}else{if((x>127)&&(x<2048)){d+=String.fromCharCode((x>>6)|192);d+=String.fromCharCode((x&63)|128)}else{d+=String.fromCharCode((x>>12)|224);d+=String.fromCharCode(((x>>6)&63)|128);d+=String.fromCharCode((x&63)|128)}}}return d}var C=Array();var P,h,E,v,g,Y,X,W,V;var S=7,Q=12,N=17,M=22;var A=5,z=9,y=14,w=20;var o=4,m=11,l=16,j=23;var U=6,T=10,R=15,O=21;s=J(s);C=e(s);Y=1732584193;X=4023233417;W=2562383102;V=271733878;for(P=0;P<C.length;P+=16){h=Y;E=X;v=W;g=V;Y=u(Y,X,W,V,C[P+0],S,3614090360);V=u(V,Y,X,W,C[P+1],Q,3905402710);W=u(W,V,Y,X,C[P+2],N,606105819);X=u(X,W,V,Y,C[P+3],M,3250441966);Y=u(Y,X,W,V,C[P+4],S,4118548399);V=u(V,Y,X,W,C[P+5],Q,1200080426);W=u(W,V,Y,X,C[P+6],N,2821735955);X=u(X,W,V,Y,C[P+7],M,4249261313);Y=u(Y,X,W,V,C[P+8],S,1770035416);V=u(V,Y,X,W,C[P+9],Q,2336552879);W=u(W,V,Y,X,C[P+10],N,4294925233);X=u(X,W,V,Y,C[P+11],M,2304563134);Y=u(Y,X,W,V,C[P+12],S,1804603682);V=u(V,Y,X,W,C[P+13],Q,4254626195);W=u(W,V,Y,X,C[P+14],N,2792965006);X=u(X,W,V,Y,C[P+15],M,1236535329);Y=f(Y,X,W,V,C[P+1],A,4129170786);V=f(V,Y,X,W,C[P+6],z,3225465664);W=f(W,V,Y,X,C[P+11],y,643717713);X=f(X,W,V,Y,C[P+0],w,3921069994);Y=f(Y,X,W,V,C[P+5],A,3593408605);V=f(V,Y,X,W,C[P+10],z,38016083);W=f(W,V,Y,X,C[P+15],y,3634488961);X=f(X,W,V,Y,C[P+4],w,3889429448);Y=f(Y,X,W,V,C[P+9],A,568446438);V=f(V,Y,X,W,C[P+14],z,3275163606);W=f(W,V,Y,X,C[P+3],y,4107603335);X=f(X,W,V,Y,C[P+8],w,1163531501);Y=f(Y,X,W,V,C[P+13],A,2850285829);V=f(V,Y,X,W,C[P+2],z,4243563512);W=f(W,V,Y,X,C[P+7],y,1735328473);X=f(X,W,V,Y,C[P+12],w,2368359562);Y=D(Y,X,W,V,C[P+5],o,4294588738);V=D(V,Y,X,W,C[P+8],m,2272392833);W=D(W,V,Y,X,C[P+11],l,1839030562);X=D(X,W,V,Y,C[P+14],j,4259657740);Y=D(Y,X,W,V,C[P+1],o,2763975236);V=D(V,Y,X,W,C[P+4],m,1272893353);W=D(W,V,Y,X,C[P+7],l,4139469664);X=D(X,W,V,Y,C[P+10],j,3200236656);Y=D(Y,X,W,V,C[P+13],o,681279174);V=D(V,Y,X,W,C[P+0],m,3936430074);W=D(W,V,Y,X,C[P+3],l,3572445317);X=D(X,W,V,Y,C[P+6],j,76029189);Y=D(Y,X,W,V,C[P+9],o,3654602809);V=D(V,Y,X,W,C[P+12],m,3873151461);W=D(W,V,Y,X,C[P+15],l,530742520);X=D(X,W,V,Y,C[P+2],j,3299628645);Y=t(Y,X,W,V,C[P+0],U,4096336452);V=t(V,Y,X,W,C[P+7],T,1126891415);W=t(W,V,Y,X,C[P+14],R,2878612391);X=t(X,W,V,Y,C[P+5],O,4237533241);Y=t(Y,X,W,V,C[P+12],U,1700485571);V=t(V,Y,X,W,C[P+3],T,2399980690);W=t(W,V,Y,X,C[P+10],R,4293915773);X=t(X,W,V,Y,C[P+1],O,2240044497);Y=t(Y,X,W,V,C[P+8],U,1873313359);V=t(V,Y,X,W,C[P+15],T,4264355552);W=t(W,V,Y,X,C[P+6],R,2734768916);X=t(X,W,V,Y,C[P+13],O,1309151649);Y=t(Y,X,W,V,C[P+4],U,4149444226);V=t(V,Y,X,W,C[P+11],T,3174756917);W=t(W,V,Y,X,C[P+2],R,718787259);X=t(X,W,V,Y,C[P+9],O,3951481745);Y=K(Y,h);X=K(X,E);W=K(W,v);V=K(V,g)}var i=B(Y)+B(X)+B(W)+B(V);return i.toLowerCase()};

      var size = size || 40;

      return 'http://www.gravatar.com/avatar/' + MD5(email) + '.jpg?s=' + size + "&d=robohash";
    },

    drawChart: function(idType, id, history) {
      var divName = idType + "--" + id + "--chart";
      $('#all_charts').append("<div id=\""+divName+"\"></div>");

      var data = new google.visualization.DataTable();
      data.addColumn('datetime', 'Date');
      data.addColumn('number', 'Schwellwert');
      for (var i = 0; i < history.length; i++) {
        data.addColumn('number', history[i].shopName);
      }

      var rows = [];
      for (var i = 0; i < history.length; i++) {
        var shop = history[i];

        for (var x = 0; x < shop.prices.length; x++) {
          var row = [null, null, null, null, null, null, null, null];
          row[0] = this.extractFlattenedDateInCorrectTimezone(shop.prices[x][0]);
          row[1] = this.product.schwellwert;
          row[i+2] = shop.prices[x][1];
          rows.push(row);
        }

      }

      data.addRows(rows);

      var chartWidth = $('#top_level_container').width();
      var options = {
        hAxis: {
          title: 'Datum'
        },
        vAxis: {
          title: 'Preis'
        },
        title: "Preis-Historie für " + idType + "=" + id,
        width: chartWidth,
        height: 400,

        series: {
            0: { color: '#000000', lineWidth: 6 },
        },
      };

      var chart = new google.visualization.LineChart(document.getElementById(divName));

      //chart.draw(data, options);
      chart.draw(data, google.charts.Line.convertOptions(options));
    },

    extractFlattenedDateInCorrectTimezone: function(dateAsString) {
      // Datum erzeugen. Das ist erstmal in der falschen Zeitzone
      var date = new Date(dateAsString);
      // Sekunden abschneiden, um die Werte fuer den Chart zu glaetten
      date.setSeconds(0);
      // Epoch shifting durchfuehren von UTC auf die lokale Zeitzone (da die Werte im String UTC waren)
      var correctedDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
      return correctedDate;
    },

    getAllIdsFromCurrentProduct: function() {
      var result = [];
      var ids = [];
      if (!ids.includes(this.product.asinEk1) && !("NONE" === this.product.asinEk1) && !(null === this.product.asinEk1)) {
        ids.push(this.product.asinEk1);
        result.push({idType: 'asin', id: this.product.asinEk1});
      }
      if (!ids.includes(this.product.asinEk2) && !("NONE" === this.product.asinEk2) && !(null === this.product.asinEk2)) {
        ids.push(this.product.asinEk2);
        result.push({idType: 'asin', id: this.product.asinEk2});
      }
      if (!ids.includes(this.product.asinVk1) && !("NONE" === this.product.asinVk1) && !(null === this.product.asinVk1)) {
        ids.push(this.product.asinVk1);
        result.push({idType: 'asin', id: this.product.asinVk1});
      }
      if (!ids.includes(this.product.asinVk2) && !("NONE" === this.product.asinVk2) && !(null === this.product.asinVk2)) {
        ids.push(this.product.asinVk2);
        result.push({idType: 'asin', id: this.product.asinVk2});
      }
      if (!ids.includes(this.product.systeam) && !("NONE" === this.product.systeam) && !(null === this.product.systeam)) {
        ids.push(this.product.systeam);
        result.push({idType: 'systeam', id: this.product.systeam});
      }
      return result;
    },

    getIdsInPrices: function(prices) {
      var ids = [];
      var result = [];
      for (var i=0; i<prices.length; i++) {
        if (!ids.includes(prices[i].id)) {
          ids.push(prices[i].id);
          result.push(prices[i]);
        }
      }
      return result;
    },

    getShopNamesForIdInPrices: function(id, prices) {
      var result = [];
      for (var i=0; i<prices.length; i++) {
        var shopName = prices[i].shopName;
        if (prices[i].id === id) {
          if (!result.includes(shopName)) {
            result.push(shopName);
          }
        }
      }
      return result;
    },

    getPricesForShopAndIdInPrices: function(id, shopName, prices) {
      var result = [];
      for (var i=0; i<prices.length; i++) {
        if (prices[i].shopName === shopName && prices[i].id === id) {
          result.push(prices[i]);
        }
      }
      result.sort(function(a, b) {
        if (a.isMainPrice) {
          return 0;
        }
        return 1;
      });
      return result;
    },

  },

}
</script>


<style scoped>
.activity {
  margin-bottom: 50px;
}
.mainPrice {
  font-weight: bold;
}
.ids {
  margin-bottom: 70px;
  border: 1px solid grey;
  padding: 25px;
  background-color: #EEEEEE;
  -webkit-box-shadow: 6px 6px 25px 0px rgba(128,124,128,1);
  -moz-box-shadow: 6px 6px 25px 0px rgba(128,124,128,1);
  box-shadow: 6px 6px 25px 0px rgba(128,124,128,1);
}
.shopNames {
  margin-top: 20px;
  margin-left: 60px;
}
</style>
